import { translate, type Dict, type Locale } from '@livequiz/shared';

/** Texte der Beamer-Ansicht in Deutsch und Englisch. */
const dict: Dict = {
  de: {
    noSessionParam: 'Kein Session-Parameter (?session=…).',
    connecting: 'Verbinde …',
    connected: 'verbunden',
    disconnected: 'getrennt',
    start: '▶ Start',
    paused: 'Pause',
    joinUnder: 'Mitmachen unter',
    joinPin: 'Beitritts-PIN',
    participantOne: 'Teilnehmer:in',
    participantMany: 'Teilnehmende',
    spaceToStart: 'Leertaste = Start',
    waitingParticipants: 'Warte auf Teilnehmende … QR scannen oder PIN eingeben',
    nextQuestion: 'Nächste Frage',
    enterOnDevice: 'Antwort am eigenen Gerät eingeben …',
    rating: 'Bewertung',
    waitInput: 'Warte auf Eingaben …',
    waitContrib: 'Warte auf Beiträge …',
    noImage: 'Kein Bild vorhanden.',
    tapOnDevice: 'Tippe auf deinem Gerät auf die richtige Stelle.',
    teamStandings: 'Team-Zwischenstand',
    standings: 'Zwischenstand',
    hardestQuestion: 'Schwierigste Frage',
    noSpinnerEntries: 'Keine Einträge – im Editor hinzufügen.',
    spinning: 'Dreht …',
    spin: '🎡 Drehen',
    spinAgain: '🎡 Nochmal',
    selected: 'Ausgewählt 🎉',
    whoseTurn: 'Wer ist dran? …',
    close: 'Schließen',
    nextSpace: 'Weiter ▶ (Leertaste)',
    skip: 'Überspringen',
    resume: 'Fortsetzen',
    pauseEsc: 'Pause (Esc)',
    endConfirm: 'Session beenden?',
    end: 'Beenden',
    drawRandom: 'Zufällige/n Teilnehmer/in ziehen',
    random: 'Zufall',
    soundEffects: 'Sound-Effekte',
    effectsOff: 'Effekte aus',
    arcade: 'Arcade',
    soft: 'Sanft',
    musicLib: 'Musik-Bibliothek',
    musicOff: 'Musik aus',
    font: 'Schrift',
    questionHeader: 'Frage {i} / {n}',
    answeredCount: '{a}/{t} geantwortet',
    bonusRound: '★ Bonusrunde · doppelte Punkte',
    answersLive: '{n} Antworten · aktualisiert live',
    answersN: '{n} Antworten',
    correctMark: 'richtig',
    correctCap: 'Richtig',
    inTargetArea: '{hits} von {total} im Zielbereich',
    votesN: '{n} Stimmen',
    contribCount: '{n} Beiträge',
    correctLabel: 'Richtig: {text}',
    final: '🏆 Endstand',
    teamFinal: '🏆 Team-Endstand',
    hardestLine: '„{prompt}" · {pct} % richtig',
    boardSubmit: 'Fragen einreichen',
    boardYours: 'Eure Fragen',
    boardQuestionsCount: '{n} Fragen',
    boardAnsweredSuffix: ' · {n} beantwortet',
    boardCode: 'Code',
    boardScanSave: 'Scannen und speichern – jederzeit Fragen stellen.',
    boardEmptyFirst: 'Noch keine Fragen – seid die Ersten!',
    boardEmpty: 'Noch keine Fragen.',
    boardHideQr: 'QR ausblenden – nur Fragen anzeigen',
    boardShowQr: 'QR/Beitritt wieder anzeigen',
    boardSpaceKey: '(Leertaste)',
  },
  en: {
    noSessionParam: 'No session parameter (?session=…).',
    connecting: 'Connecting …',
    connected: 'connected',
    disconnected: 'disconnected',
    start: '▶ Start',
    paused: 'Paused',
    joinUnder: 'Join at',
    joinPin: 'Join PIN',
    participantOne: 'Participant',
    participantMany: 'Participants',
    spaceToStart: 'Space = Start',
    waitingParticipants: 'Waiting for participants … scan the QR code or enter the PIN',
    nextQuestion: 'Next question',
    enterOnDevice: 'Enter your answer on your own device …',
    rating: 'Rating',
    waitInput: 'Waiting for input …',
    waitContrib: 'Waiting for contributions …',
    noImage: 'No image available.',
    tapOnDevice: 'Tap the correct spot on your own device.',
    teamStandings: 'Team standings',
    standings: 'Standings',
    hardestQuestion: 'Hardest question',
    noSpinnerEntries: 'No entries – add them in the editor.',
    spinning: 'Spinning …',
    spin: '🎡 Spin',
    spinAgain: '🎡 Again',
    selected: 'Selected 🎉',
    whoseTurn: 'Who’s up? …',
    close: 'Close',
    nextSpace: 'Next ▶ (Space)',
    skip: 'Skip',
    resume: 'Resume',
    pauseEsc: 'Pause (Esc)',
    endConfirm: 'End the session?',
    end: 'End',
    drawRandom: 'Draw a random participant',
    random: 'Random',
    soundEffects: 'Sound effects',
    effectsOff: 'Effects off',
    arcade: 'Arcade',
    soft: 'Soft',
    musicLib: 'Music library',
    musicOff: 'Music off',
    font: 'Font',
    questionHeader: 'Question {i} / {n}',
    answeredCount: '{a}/{t} answered',
    bonusRound: '★ Bonus round · double points',
    answersLive: '{n} answers · updating live',
    answersN: '{n} answers',
    correctMark: 'correct',
    correctCap: 'Correct',
    inTargetArea: '{hits} of {total} in the target area',
    votesN: '{n} votes',
    contribCount: '{n} contributions',
    correctLabel: 'Correct: {text}',
    final: '🏆 Final standings',
    teamFinal: '🏆 Team final standings',
    hardestLine: '"{prompt}" · {pct}% correct',
    boardSubmit: 'Submit questions',
    boardYours: 'Your questions',
    boardQuestionsCount: '{n} questions',
    boardAnsweredSuffix: ' · {n} answered',
    boardCode: 'Code',
    boardScanSave: 'Scan and save – ask questions anytime.',
    boardEmptyFirst: 'No questions yet – be the first!',
    boardEmpty: 'No questions yet.',
    boardHideQr: 'Hide QR – show questions only',
    boardShowQr: 'Show QR/join again',
    boardSpaceKey: '(Space)',
  },
};

export type TFn = (key: string, params?: Record<string, string | number>) => string;
export function makeT(locale: Locale): TFn {
  return (key, params) => translate(dict, locale, key, params);
}
